import type { OAuthConsentTranslations } from '../interfaces/oauth';

export const oauthTranslations: OAuthConsentTranslations = {
  title: 'Autorizar acesso',
  subtitle: '{{client}} está solicitando acesso à sua conta {{brand}}.',
  scopeSectionLabel: 'Permissões solicitadas',
  scopeMcpDescription:
    'Usar as ferramentas MCP da {{brand}} em seu nome (ler e executar ações da sua conta).',
  loggedInAs: 'Conectado como',
  allowButton: 'Permitir acesso',
  denyButton: 'Negar',
  deniedTitle: 'Acesso negado',
  deniedMessage: 'Você não autorizou a conexão. Nenhum acesso foi concedido.',
  closeWindowHint: 'Você já pode fechar esta janela.',
  invalidRequestTitle: 'Solicitação inválida',
  invalidRequestMessage:
    'Esta solicitação de autorização é inválida ou expirou. Reinicie o processo a partir do seu aplicativo.',
  backToApp: 'Ir para a {{brand}}',
  approveErrorToast: 'Não foi possível concluir a autorização. Tente novamente.',
  loading: 'Carregando solicitação…',
};
